<template>
  <div class="select-payment">
    <ShadowBox class="shadow-box" opacity="_60">
      <span class="select-payment-title">{{t('決済方法を選択')}}</span>
      <span v-for="(payment) in paymentList" :key="payment.id" class="pay_list">
        <RadioItem
          class="radio-item"
          :paymentId="payment.id"
          :name="payment.name"
          :memo="payment.memo"
          :isChecked="currentPaymentId === payment.id"
          @handleRadioBtnClick="handleRadioBtnClick"
        />
        <div class="credit_area" v-if="currentPaymentId === 1 && payment.id === 1">
          <span
            v-if="pointSavedCard && pointSavedCard.card_list.length > 0"
          >
            <span
              v-for="(card, i) in pointSavedCard.card_list"
              :key="i"
            >
              <div class="flex">
                <RadioItem
                  class="radio-item"
                  :paymentId="card.id"
                  :name="card.card"
                  memo=""
                  :isChecked="savedCardIndex == card.id"
                  @handleRadioBtnClick="handleSavedCardClick"
                />
                <SquareButton
                  class="square-button delete-button"
                  :text="t('削除')"
                  :isSub="true"
                  @handleSquareBtnClick="executeDeleteCard(i)"
                />
              </div>
            </span>
          </span>
          <RadioItem
            v-if="pointSavedCard && pointSavedCard.card_list.length > 0"
            class="radio-item"
            paymentId="99999"
            name="新たにカードを登録する"
            memo=""
            :isChecked="savedCardIndex == 99999"
            @handleRadioBtnClick="handleSavedCardClick"
          />
          <span v-if="savedCardIndex == 99999">
            <div class="credit_icon" v-if="currentPaymentId === 1 && payment.id === 1">
              <img src="/img/credit/visa.png">
              <img src="/img/credit/master.png">
              <img src="/img/credit/jcb.png">
              <img src="/img/credit/amex.png">
              <img src="/img/credit/dc.png">
              <img src="/img/credit/diners.png">
            </div>
            <div v-if="currentPaymentId === 1 && payment.id === 1" class="area-base">
              <LabelInput class="label-input" :labelText="t('カード番号')">
                <div class="card-area">
                  <div class="last-name-container" style="width: 100%;">
                    <TextBox
                      class="text-box last-name input-center"
                      inputType="tel"
                      v-model="card_number"
                      placeholder=""
                      maxlength="20"
                      @handleTextInput="handleTextInput('card_number01', $event)"
                    />
                  </div>
                </div>
              </LabelInput>
              <div class="card_flex">
                <LabelInput class="label-input" :labelText="t('有効期限')" style="width:220px;">
                  <div class="card-area">
                    <div class="last-name-container">
                      <TextBox
                        class="text-box last-name input-center"
                        inputType="tel"
                        v-model="limit_month"
                        placeholder="月"
                        maxlength="2"
                        @handleTextInput="handleTextInput('limit_month', $event)"
                      />
                    </div>
                    <div class="first-name-container">
                      <TextBox
                        class="text-box first-name input-center"
                        inputType="tel"
                        v-model="limit_year"
                        placeholder="年"
                        maxlength="2"
                        @handleTextInput="handleTextInput('limit_year', $event)"
                      />
                    </div>
                  </div>
                </LabelInput>
                <LabelInput
                  class="label-input"
                  :labelText="t('セキュリティコード')"
                  style="width:380px;white-space: nowrap;"
                >
                  <div class="card-area">
                    <div class="last-name-container" style="width:100%;">
                      <TextBox
                        class="text-box last-name input-center"
                        inputType="tel"
                        v-model="cvc"
                        placeholder="CVC"
                        maxlength="4"
                        @handleTextInput="handleTextInput('cvc', $event)"
                      />
                    </div>
                  </div>
                </LabelInput>
              </div>
              <LabelInput class="label-input" :labelText="t('カード名義')" style="width:100%;">
                <div class="card-row">
                  <div class="last-name-container">
                    <TextBox
                      class="text-box last-name"
                      inputType="text"
                      v-model="card_name"
                      placeholder=""
                      maxlength="20"
                      @handleTextInput="handleTextInput('card_name', $event)"
                    />
                  </div>
                </div>
              </LabelInput>
              <div class="saved_card_button">
                <OrangeGradationButton
                  class="square-button"
                  text="このカード情報を保存する"
                  @handleSquareBtnClick="savedCardInfo"
                />
              </div>
            </div>
          </span>
        </div>
        <div v-if="currentPaymentId === 2 && payment.id === 2" style="margin-left: 20px">
          <RadioItem
            v-for="(combini) in combini_list"
            :key="combini.id"
            class="radio-item"
            :paymentId="payment.id"
            :name="combini.name"
            :memo="combini.memo"
            :isChecked="currentCombiniCode === combini.code"
            @handleRadioBtnClick="handleCombiniBtnClick(combini.code)"
          />
        </div>
        <div v-if="currentPaymentId === 6 && payment.id === 6" style="margin-left: 20px">
          <RadioItem
            v-for="(carrier) in carrier_list"
            :key="carrier.id"
            class="radio-item"
            :paymentId="payment.id"
            :name="carrier.name"
            :memo="carrier.memo"
            :isChecked="currentCarrierCode === carrier.code"
            @handleRadioBtnClick="handleCarrierBtnClick(carrier.code)"
          />
        </div>
        <LabelInput
          v-if="currentPaymentId === 4 && payment.id === 4"
          class="label-input"
          labelText="振込口座名義"
          annotation="振込人名義（カタカナ）をご入力ください"
          style="width:100%;">
          <div class="card-row">
            <div class="last-name-container">
              <TextBox
                class="text-box area-base"
                inputType="text"
                placeholder=""
                @handleTextInput="handleAccountHolderChange"
              />
            </div>
          </div>
        </LabelInput>
<!--        <TextBox-->
<!--          v-if="currentPaymentId === 4 && payment.id === 4"-->
<!--          style="width: 90%;"-->
<!--          class="text-box area-base"-->
<!--          @handleTextInput="handleAccountHolderChange"-->
<!--        />-->
        <div
          v-if="payment.id === 5"
          v-show="currentPaymentId === 5"
        >
          <AmazonPayButton
            @defaultAmazonPay="handleRadioBtnClick"
          >
          </AmazonPayButton>
        </div>
        <div
          v-if="payment.id === 12"
          v-show="currentPaymentId === 12"
        >
          <GooglePayButton
            :price="price"
            @defaultGooglePay="handleGoogleBtnClick"
          >
          </GooglePayButton>
        </div>
        <div
          v-if="payment.id === 3"
          v-show="currentPaymentId === 3"
        >
          <PayPalButton
            :amount="currentPointPrice.price"
            @payPalOnApprove="payPalOnApprove"
          >
          </PayPalButton>
        </div>
      </span>
      <ErrorMessage
        v-if="errorMessageAccountHolder"
        class="error-message"
        :message="errorMessageAccountHolder"
      />
    </ShadowBox>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ShadowBox from '@/components/atoms/ShadowBox.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import RadioItem from '@/components/molecules/RadioItem.vue';
import LabelInput from '@/components/molecules/LabelInput.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import AmazonPayButton from '@/components/atoms/AmazonPayButton.vue';
import GooglePayButton from '@/components/atoms/GooglePayButton.vue';
import PayPalButton from '@/components/atoms/PayPalButton.vue';
import OrangeGradationButton from '@/components/atoms/OrangeGradationButton.vue';
import t from '@/plugins/i18n';
import axios from 'axios';

export default {
  name: 'SelectPayment',
  mixins: [t],

  components: {
    ShadowBox,
    TextBox,
    ErrorMessage,
    RadioItem,
    LabelInput,
    AmazonPayButton,
    GooglePayButton,
    PayPalButton,
    SquareButton,
    OrangeGradationButton,
  },

  computed: {
    ...mapGetters({
      pointSavedCard: 'user/pointSavedCard',
      saveCard: 'user/saveCard',
      deleteCard: 'user/deleteCard',
    }),
  },

  data: () => ({
    card_number: '',
    limit_month: '',
    limit_year: '',
    cvc: '',
    card_name: '',
    combini_list: [
      {
        id: 3,
        code: 'econ',
        name: 'ローソン、ファミリーマート',
        memo: '(ミニストップ、セイコーマート含む)',
      },
      // {
      //   id: 1,
      //   code: 'sej',
      //   name: 'セブン－イレブン',
      //   memo: '',
      // },
      {
        id: 2,
        code: 'other',
        name: 'デイリーヤマザキ、ヤマザキデイリーストア',
        memo: '',
      },
    ],
    carrier_list: [
      {
        id: 1,
        code: 'sb_ktai',
        name: 'ソフトバンクまとめて支払い',
        memo: '',
      },
      {
        id: 2,
        code: 'au',
        name: 'au かんたん決済',
        memo: '',
      },
      // {
      //   id: 3,
      //   code: 'docomo',
      //   name: 'd 払い',
      //   memo: '',
      // },
    ],
    savedCardIndex: 0,
  }),

  props: {
    paymentList: {
      type: Array,
    },
    currentPaymentId: {
      type: Number,
    },
    price: {
      type: Number,
    },
    currentCombiniCode: {
      type: String,
    },
    currentCarrierCode: {
      type: String,
    },
    errorMessageAccountHolder: {
      type: String,
      default: null,
    },
    currentPointPrice: {
      type: Object,
    },
  },

  watch: {
    pointSavedCard(newVal) {
      if (newVal.card_list.length > 0) {
        this.savedCardIndex = 0;
      } else {
        this.savedCardIndex = 99999;
      }
    },
    saveCard(newVal) {
      if (newVal.result !== 'success') {
        window.alert('カード情報の保存に失敗しました。(既に登録されているなど)');
      } else {
        this.$store.dispatch('user/setPointSavedCard');
      }
    },
    deleteCard(newVal) {
      if (newVal.result !== 'success') {
        window.alert('カード情報の削除に失敗しました。');
      } else {
        this.$store.dispatch('user/setPointSavedCard');
      }
    },
  },

  created() {
    this.$store.dispatch('user/setPointSavedCard');
  },

  methods: {
    handleRadioBtnClick(paymentId) {
      this.$emit('handleRadioBtnClick', paymentId);
    },
    handleCombiniBtnClick(code) {
      this.$emit('handleCombiniBtnClick', code);
    },
    handleCarrierBtnClick(code) {
      this.$emit('handleCarrierBtnClick', code);
    },
    handleAccountHolderChange(accountHolder) {
      this.$emit('handleAccountHolderChange', accountHolder);
    },
    handleGoogleBtnClick(paymentData) {
      this.$emit('handleGooglepay', paymentData);
    },
    handleTextInput(code, value) {
      this.$emit(code, value);
    },
    getData() {
      return {
        card_index: this.savedCardIndex,
        card_number: this.card_number,
        limit_month: this.limit_month,
        limit_year: this.limit_year,
        cvc: this.cvc,
        card_name: this.card_name,
      };
    },
    payPalOnApprove(modifiedDetails) {
      this.$emit('payPalOnApprove', modifiedDetails);
    },
    handleSavedCardClick(savedCardIdx) {
      this.savedCardIndex = savedCardIdx;
    },
    executeDeleteCard(index) {
      if (!window.confirm('このカードを削除しますか？')) {
        return;
      }
      const postParams = {
        card_index: index,
      };
      this.$store.dispatch('user/deleteCard', { postParams });
    },
    savedCardInfo() {
      this.checkVeritrans();
    },
    checkVeritrans() {
      const month = (`0${this.limit_month}`).slice(-2);
      const year = (`0${this.limit_year}`).slice(-2);
      const param = {
        card_number: this.card_number,
        card_expire: `${month}/${year}`,
        security_code: this.cvc,
        cardholder_name: this.card_name,
        token_api_key: process.env.VUE_APP_VERITRANS_TOKEN,
      };

      const axiosCtrl = axios.create();
      axiosCtrl.post('https://api.veritrans.co.jp/4gtoken', param).then(
        (res) => {
          if (res.data.code === 'success') {
            const postParams = {
              pay_id: this.currentPaymentId,
              token: res.data.token,
              req_card_number: res.data.req_card_number,
              card_user_name: param.cardholder_name,
            };
            this.$store.dispatch('user/saveCard', { postParams });
          } else {
            window.alert('ご入力いただいたカード情報が確認できませんでした。\n再度ご入力内容をご確認ください。');
          }
        },
      ).catch(
        (err) => {
          console.log(err);
          window.alert('ご入力いただいたカード情報が確認できませんでした。\n再度ご入力内容をご確認ください。');
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.select-payment{
  width: 100%;
  .shadow-box{
    padding: 15px 20px;
    border-radius: 6px;
    flex-direction: column;
    align-items: flex-start;
    .credit_icon {
      display: flex;
      margin: 5px 0 5px 0;
      justify-content: flex-start;
      align-items: center;
      img {
        width: 52px;
        margin: 2px;
      }
    }
    .pay_list {
      width: 600px;
      margin: 10px auto;
      .label-input {
        margin-top: 20px;
      }
    }
    .select-payment-title{
      font-family: $notoSansJP;
      font-size: 20px;
      // color: $white;
      text-align: left;
      display: block;
      width: 100%;
      padding-bottom: 10px;
      border-bottom: solid 1px $yellow;
      margin-bottom: 20px;
    }
    .radio-item{
      margin-top: 10px;
    }
    .text-box{
      width: 100%;
      margin-top: 5px;
      padding-left: 30px;
    }
  }
}
.credit_area {
  margin-left: 10px;
}
.saved_card_button {
  margin: 10px auto 0 auto;
  padding: 0 20px;
  max-width: 300px;
}
.flex {
  display: flex;
  .delete-button {
    margin-top: 10px;
    margin-left: 20px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .select-payment{
    .shadow-box{
      padding: 15px 0;
      .credit_icon {
        img {
          width: 36px;
        }
      }
      .pay_list {
        width: 100%;
      }
      .select-payment-title{
        border-bottom: solid 1px $deepGray;
        padding-bottom: 20px;
        margin: 0 0 10px 0;
      }
    }
  }
}
</style>
<style lang="scss">
.area-base {
  margin-left: 0;
  .card_flex {
    display: flex;
  }
  .card-area {
    display: flex;

    div {
      margin-right: 8px;
    }
    .input-center {
      padding-left: 0!important;
      padding-right: 0!important;
      input {
        text-align: center!important;
      }
    }
  }
  .card-row {
    div {
      margin-right: 8px;
    }
  }
}
</style>
